import { Component, OnInit } from '@angular/core';
import { AuthService } from "src/app/shared/services/auth/auth.service";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { NgForm, FormsModule } from "@angular/forms";
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  getaddress: any = {};
  user: any = "";
  is_authenticate_user: boolean = false;
  subTotal: any = 0;
  grandTotal: any = 0
  usercartRequest = {
    auth_key: this.user.auth_key
  };
  usercartList: any = "";
  checkoutReques: any = {};
  paymentReques: any = {};
  graceroad: any = "No";
  usercarlist = "";
  paymentres: any = "";
  useradd: any = 0;
  addressRequest: any = {};
	addressError: any;
  	addressSuccess: any;
    updateRequest: any = {};
	updateError: any;
  	updateSuccess: any;
    count: any = 0;
    finalcount: any = 0;
    minimumcharg: any = "";
    shipingcharg: any = 6.0;
    finalcharge : any ="";
    totalItems: any = 0;
    shippingcharge: any = 0;
    remaining: any =0;
    

  constructor(
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private router: Router,) { }

  ngOnInit() {

    this.addressRequest = {
      phone_code: 91,
      latitude: 23.123456,
      longitude: 72.123456,
      is_default: "Yes",
      
    };

    this.updateRequest = {
      phone_code: 91,
      latitude: 23.123456,
      longitude: 72.123456,
      is_default: "Yes",
      
    };
    
    if (this.authService.isLoggedIn == true) {

      this.is_authenticate_user = true;
      this.loadcart();
    } else {
      this.router.navigate(['/login']);
    }
    this.authService.$user.subscribe((data) => {
      console.log("login j chhhhe");
      //console.log(data);
      if (data) {
        this.user = data;
        console.log(this.user);
      } else {
        this.user = null;
      }
    });
    this.getAddress();
   
      jQuery(".custom-select-top a").click(function(){
        jQuery(".custom-select").addClass("main");
      });
      jQuery(".custom-select-top-two a").click(function(){
        jQuery(".custom-select-two").addClass("main");
      });
      jQuery(".custom-select-list li a").click(function(){
        jQuery(".custom-select").removeClass("main");
      });
      jQuery(".custom-select-list-two li a").click(function(){
        jQuery(".custom-select-two").removeClass("main");
      });
      jQuery(".checkout-one-btn").click(function(){
        jQuery(".checkout-form-left").addClass("open");
        return false;
      });
      
      
      
      // jQuery(".radio-btn-two .checkmark").click(function(){
      //   jQuery(".checkout-form-btn").addClass("intro");
      //   return false;
      // });
      jQuery(".checkout-radio-box.radio-btn-one input.radio-btn:radio").click((e) => {
        jQuery('.checkout-form-btn').removeClass('disabled');
        jQuery('.new-delivery-address').removeClass('disabled');
        jQuery('.checkout-form-btn').removeClass('close');
        this.graceroad = "No";
      });
      jQuery(".checkout-radio-box.radio-btn-two input.radio-btn:radio").click((e) => {
        jQuery('.checkout-form-btn').addClass('disabled');
        jQuery('.new-delivery-address').removeClass('disabled');
      });
      jQuery(".checkout-radio-box.radio-btn-three input.radio-btn:radio").click((e) => {
        jQuery('.new-delivery-address').addClass('disabled');
        jQuery('.checkout-form-btn').removeClass('disabled');
        jQuery('.checkout-form-btn').addClass('close');
        this.graceroad = "No";
      });
      jQuery(".custom-select-list li").click(function(){
        var currentcontname = jQuery(this).find(".name").html();
        var currentcontcode = jQuery(this).find(".number").html();
        var currentflag = jQuery(this).find("span").eq(0).attr("class");
        jQuery(".custom-select-top a.selected_cont span").removeClass();
        jQuery(".custom-select-top a.selected_cont span").addClass(currentflag);
        jQuery("#country_code").val(currentcontcode);
        jQuery("#country_name").val(currentcontname);
    
      });
      
   
    
    
    jQuery(".checkout-one-btn").click(function(){
      jQuery(".checkout-form-left").addClass("open");
      return false;
    });
    // jQuery(".checkout-two-btn").click(function(){
    //   jQuery(".checkout-form-left").addClass("intro");
    //   return false;
    // });
    // jQuery(".radio-btn-two .checkmark").click(function(){
    //   jQuery(".checkout-form-btn").addClass("intro");
    //   return false;
    // });
    jQuery(".checkout-radio-box.radio-btn-one input.radio-btn:radio").click((e) => {
      jQuery('.checkout-form-btn').removeClass('disabled');
      jQuery('.new-delivery-address').removeClass('disabled');
      this.graceroad = "No";
    });
    jQuery(".checkout-radio-box.radio-btn-two input.radio-btn:radio").click((e) => {
      jQuery('.checkout-form-btn').addClass('disabled');
      jQuery('.new-delivery-address').removeClass('disabled');
    });
    jQuery(".checkout-radio-box.radio-btn-three input.radio-btn:radio").click((e) => {
      jQuery('.new-delivery-address').addClass('disabled');
      jQuery('.checkout-form-btn').removeClass('disabled');
      this.graceroad = "No";
    });
    jQuery(".custom-select-list li").click(function(){
      var currentcontname = jQuery(this).find(".name").html();
      var currentcontcode = jQuery(this).find(".number").html();
      var currentflag = jQuery(this).find("span").eq(0).attr("class");
      jQuery(".custom-select-top a.selected_cont span").removeClass();
      jQuery(".custom-select-top a.selected_cont span").addClass(currentflag);
      jQuery("#country_code").val(currentcontcode);
      jQuery("#country_name").val(currentcontname);
  
    });
    jQuery(".checkout-three-btn").click(function(){
      jQuery(".checkout-form-four-your").addClass("pay");
      jQuery(".checkout-form-left intro").removeClass("open");
      jQuery(".checkout-form-left ").removeClass("intro");
      jQuery(".checkout-form-left ").addClass("pay");
      return false;
    });    

    jQuery(".checkout-confirm-pay-btn").click(function(){
      jQuery(".checkout-form-four-your").addClass("pay");
      jQuery(".checkout-form-left intro").removeClass("open");
      jQuery(".checkout-form-left ").removeClass("intro");
      jQuery(".checkout-form-left ").addClass("pay");
      return false;
    });
    
   
  
  }
  getAddress(){
    this.authService.getAddress().then((data) => {
      this.getaddress = data.data[0];
      console.warn( this.getaddress);
      //console.warn(this.getaddress);
      this.useradd = this.getaddress.user_address_id;
      this.updateRequest.full_name = this.getaddress.full_name;
      this.updateRequest.address1 = this.getaddress.address1;
      this.updateRequest.address2 = this.getaddress.address2;
      this.updateRequest.city = this.getaddress.city;
      this.updateRequest.state = this.getaddress.state;
      this.updateRequest.country = this.getaddress.country;
      this.updateRequest.pincode = this.getaddress.pincode;
      this.updateRequest.contact = this.getaddress.contact;

     // jQuery("#address1").val(this.getaddress.address1);
    });
  }

  onSubmit(form: NgForm, e: any) { 
    e.target.submit();
  }
  doAddress(form: NgForm){

    this.addressRequest.full_name = this.addressRequest.first_name + " "+this.addressRequest.last_name

   
    if (form.valid) {
      console.log(this.addressRequest.email);
      
      let request:any = {
       
      };
      request = Object.assign({}, this.addressRequest);
      //console.log(request);
      this.authService.addAddress(request).then(
        (res) => {
          console.log(res);
          if(res.status==0)
          {
            this.addressError = res.message;
          }else{
            this.useradd = res.data.user_address_id
            console.warn(this.useradd);
            this.chekout();
          }
            
        
        }).catch((err) => {
          console.log(err);
          this.addressError = err.error.message;
        });
        
          jQuery(".checkout-form-four-your").addClass("pay");
          jQuery(".checkout-form-left intro").removeClass("open");
          jQuery(".checkout-form-left ").removeClass("intro");
          jQuery(".checkout-form-left ").addClass("pay");
         
    }
    
  }

  updateaddress(form: NgForm){
    if (form.valid) {
    
      //this.updateRequest.user_address_id = this.useradd;
      console.log(this.updateRequest.email);
      
      let request:any = {
       
      };
      request = Object.assign({}, this.updateRequest);
      //console.log(request);
      this.authService.updateAddress(request, this.useradd).then(
        (res) => {
          console.log(res);
          if(res.status==0)
          {
            this.addressError = res.message;
          }else{
            this.useradd = res.data.user_address_id
            console.warn(this.useradd);
            //this.chekout();
            setTimeout(function () {
            // jQuery(".checkout-two-btn").click(function(){
              jQuery(".checkout-form-left").addClass("intro");
              return false;
            // });
          }, 1000);
          }
            
        
        }).catch((err) => {
          console.log(err);
          this.addressError = err.error.message;
        });
        
          // jQuery(".checkout-form-four-your").addClass("pay");
          // jQuery(".checkout-form-left intro").removeClass("open");
          // jQuery(".checkout-form-left ").removeClass("intro");
          // jQuery(".checkout-form-left ").addClass("pay");
         
    }

  }



  loadcart() {
    this.subTotal = 0;
    let request = Object.assign({}, this.usercartRequest);
    this.authService.getUsercart(request).then((res) => {
      this.usercartList = res.data;
      //console.log(this.usercartList);
      this.usercartList.forEach((cart) => {
        cart.itemTotal = parseInt(cart.amount) * parseInt(cart.quantity);
        this.subTotal = parseInt(this.subTotal) + parseInt(cart.itemTotal);
        this.count++;
        //console.log(this.subTotal);
        this.usercarlist += cart.user_cart_id + ",";
      });
      this.totalItems = this.usercartList.length;
      if(this.usercartList.length > 0){
        if(this.usercartList.length == 1){
          this.shipingcharg = 6;
        }else{
          this.remaining = parseInt(this.usercartList.length) - 1;
          this.shipingcharg = parseInt(this.remaining) * 0.5;
          this.shipingcharg = parseFloat(this.shipingcharg) + 6.0;
        }
      }
      this.usercarlist = this.usercarlist.replace(/,(?=\s*$)/, "");
      //console.log(this.usercarlist);
      this.grandTotal = parseInt(this.subTotal) + parseFloat(this.shipingcharg);



    }).catch((err) => {
      //console.log(err);
    });
  }

  selectgraceroad() {
    
    this.graceroad = "Yes";
    console.log(this.graceroad);
  }

  chekout(){
    if (this.authService.isLoggedIn == true) {

      this.is_authenticate_user = true;
      this.checkoutReques = { 
        //auth_key: this.user.auth_key,
        user_address_id : this.useradd,
        cartlist: this.usercarlist,
        payment_type: "Online",        
        payment_status: "",
        is_grace_road: this.graceroad,
        other_charges: this.shipingcharg
      };
     
      let request: any = {
      };
      request = Object.assign({}, this.checkoutReques);
      this.authService.checkout(request).then(
        (res) => {
          if (res.status == 1) {
                //console.log(res);
                var finalamount = res.data.total.toFixed(2);
                finalamount = parseInt(finalamount.replace('.', ""));
                jQuery("#amount").val(finalamount);
                jQuery("#transactionUnique").val(res.data.user_order_id);
                this.paymentReques = {
                  paymentrequest : 1,
                  amount : finalamount,
                  user_order_id : res.data.user_order_id
                }

                let request = Object.assign({}, this.paymentReques);
                this.authService.paymentrequest(request).then((res) => {
                  console.log(res);
                  if (res.status == 1) {
                    jQuery("#signature").val(res.response);
                    jQuery("#payment_cta").addClass('active');
                  }
                }).catch((err) => {
                  console.log(err);
                });
              }
              //console.log(res.data);
              /*this.addedtocartPopup();*/
            }).catch((err) => {
              //console.log(err);
            });

      
    } else {
      this.router.navigate(['/login']);
    }

  }

  

  
}
function user_address_id(request: any, user_address_id: any) {
  throw new Error('Function not implemented.');
}

